import { createIdentifier } from '@blocksuite/global/di';
import type { EditorHost } from '@blocksuite/std';

// Mirror of the identifier registered by the database block's own
// `host-context.ts`. Same identifier name (`'editor-host'`) means both resolve
// the same registered `EditorHost` instance without taking a dependency from
// data-view back into the database block package.
export const EditorHostKey = createIdentifier<EditorHost>('editor-host');
